import httpAuth from '@/services/httpAuth'

import { serialize2 } from '@/services/object'

export async function list (filtros, all = false) {
  // return httpAuth.get(`/admin/ecommerce_carrinho?${serialize(filtros)}`, { tela: 'ecommerce_carrinho_fase' })
  return httpAuth.get(`/admin/ecommerce_carrinho?${serialize2(filtros)}`, { tela: 'ecommerce_carrinho_fase' })
}

export async function get (id) {
  return httpAuth.put(`/admin/ecommerce_carrinho/${id}`)
}

export async function edit (id, dados) {
  return httpAuth.put(`/admin/ecommerce_carrinho/${id}`, dados)
}

export async function updateFaseCarrinhos (carrinhos) {
  return httpAuth.post('/crm/updatefasecarrinhos', { carrinhos })
}

export async function updateVendedorCarrinhos (carrinhos) {
  return httpAuth.post('/crm/updatevendedorcarrinhos', { carrinhos })
}

export async function apiConfirmarPedido (id, dados) {
  return httpAuth.put(`/admin/ecommerce_carrinho/confirmarpedido/${id}`, dados)
}
